import {PRIVILEGED_ROLES} from "../constants";

const defaultConfigurationRow = {
  service_id: "",
  type: "",
  name: "",
  title: "",
  description: "",
  column_name: "",
  recursive_question_id: null,
  order: null,
  step_id: null,
  input_id: null,
  input_type: null,
  product_id: null,
  output_input_id: null,
  option_value: null,
  dependencies: [],
  alert_type: null,
  active: false,
  calculation: [],
  output_type: null,
  image_filename: "",
  required: false,
  output_currency: false,
  output_thickness: 2,
  output_ceil: false,
  hidden_question: [],
  metadata_question: [],
  button_select_question: false,
  flg_output_visibility: null,
  flg_subtotal: false,
  r_perm: ["public"],
  w_perm: [...PRIVILEGED_ROLES, "field"],
};

export default defaultConfigurationRow;
